import React from 'react';
import { SmartContainer } from '../../../styles/Containers';
import { Like } from '../UserEngagement/Like';
import { useEngagement } from '../UserEngagement/redux/userengagement.actions';
import { Save } from '../UserEngagement/Save';
export const AssetEngagement = ({ modelId, modelType }) => {
    const { loading, engagements } = useEngagement({ modelId, modelType });
    return (
        <SmartContainer flex justify="flex-end" align="center">
            <Like modelId={modelId} modelType={modelType} />
            <Save modelId={modelId} modelType={modelType} />
        </SmartContainer>
    )
}